/* eslint-disable no-unused-vars */
import { Palette } from 'config';
import styled, { css } from 'styled-components';

export const TooltipWrap = styled.div`
  position: relative;
  display: flex;
  font-size: 12px;
  line-height: 16px;

  &::before {
    content: ' ';
    position: absolute;
    top: 50%;
    left: ${({ tooltipPlacement }) => (tooltipPlacement === 'left' ? '0' : 'unset')};
    right: ${({ tooltipPlacement }) => (tooltipPlacement === 'right' ? '0' : 'unset')};
    width: 8px;
    height: 8px;
    background-color: ${Palette.White._100};
    transform: ${({ tooltipPlacement }) =>
      tooltipPlacement === 'left'
        ? 'translate(-50%, -50%) rotate(45deg)'
        : 'translate(50%, -50%) rotate(45deg)'};
  }
`;

export const Day = styled.div`
  width: 100%;
  text-align: center;
  font-weight: 500;
  padding: 8px;
  padding-right: 24px;
`;

export const LeftSide = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  background-color: ${Palette.White._100};
  padding: 8px 16px;
  min-width: 200px;
  overflow: hidden;
  border-radius: 4px;
  box-shadow: 0px 0px 18px rgba(23, 43, 77, 0.08), 0px 8px 24px rgba(23, 43, 77, 0.08);
`;

export const RightSide = styled.div`
  background-color: ${Palette.PrimaryGray._000};
  padding: 16px;
  width: 200px;

  & svg {
    width: 24px;
    height: 24px;

    rect {
      fill: ${Palette.Amber._100} !important;
    }
  }
`;

export const MetricWrap = styled.tr`
  width: 100%;
  gap: 4px;
  font-size: 12px;
  margin-bottom: 8px;
`;

export const Point = styled.div`
  border-radius: 4px;
  width: 8px;
  height: 8px;
  background-color: ${({ color }) => `${color.background}`};
  border-style: solid;
  border-width: 2px;
  border-color: ${({ color }) => `${color.main}`};
  margin: auto 4px;
`;

export const Title = styled.td`
  text-transform: capitalize;
  white-space: nowrap;
  min-width: 24px;
`;

export const Value = styled.td`
  text-align: right;
  font-weight: 500;
  min-width: 24px;
`;

export const NoteText = styled.div`
  padding-top: 8px;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 7;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
